// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var CssJs = require("bs-css-emotion/src/CssJs.bs.js");
var Caml_option = require("@rescript/std/lib/js/caml_option.js");
var Particle_Screen_Ds = require("./Particle_Screen_Ds.bs.js");
var Particle_Spacer_Ds = require("./Particle_Spacer_Ds.bs.js");
var Particle_Spacer_Constants = require("./Particle_Spacer_Constants.bs.js");

var $$default = Particle_Screen_Ds.make(undefined, undefined, Caml_option.some(Particle_Spacer_Constants.Zone.desktop), undefined, undefined, Particle_Spacer_Constants.Zone.mobile);

var Zone = {
  $$default: $$default
};

var empty = Particle_Screen_Ds.make(undefined, undefined, Caml_option.some(Particle_Spacer_Constants.allZero), undefined, undefined, Particle_Spacer_Constants.allZero);

var oneHundredPctWidth = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, CssJs.pct(100));

var oneHundredPctMaxWidth = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, CssJs.pct(100));

var oneHundredPctHeight = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, CssJs.pct(100));

var oneHundredPctMaxHeight = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, CssJs.pct(100));

var alignItemsCenter = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "center");

var alignItemsFlexStart = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "flexStart");

var alignItemsFlexEnd = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "flexEnd");

var alignSelfStart = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "flexStart");

var alignSelfCenter = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "center");

var alignSelfEnd = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "flexEnd");

var justifyContentCenter = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "center");

var justifyContentSpaceBetween = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "spaceBetween");

var justifyContentSpaceAround = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "spaceAround");

var justifyContentFlexStart = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, CssJs.flexStart);

var justifyContentFlexEnd = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, CssJs.flexEnd);

var mInnerSpace = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "M");

var sInnerSpace = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "S");

var xsInnerSpace = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XS");

var xxsInnerSpace = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XXS");

var xxsGap = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XXS");

var mGap = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "M");

var xxsVerticalBlockSpace = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeVertical("XXS"));

var xxsBottomBlockSpace = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeBottom("XXS"));

var xsBottomBlockSpace = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeBottom("XS"));

var mBottomBlockSpace = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeBottom("M"));

var lBottomBlockSpace = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeBottom("L"));

var lTopBlockSpace = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeTop("L"));

var emptyRules = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, []);

var flexDirectionRow = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, CssJs.row);

var flexDirectionColumn = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, CssJs.column);

var autoSizeAllPlaceNeeded = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, /* AllPlaceNeeded */1);

var autoSizeAllPlaceAvailable = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, /* AllPlaceAvailable */0);

var autoSizeNoResizing = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, /* NoResizing */3);

var displayInlineFlex = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "inlineFlex");

var displayInline = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "inline");

exports.Zone = Zone;
exports.empty = empty;
exports.oneHundredPctWidth = oneHundredPctWidth;
exports.oneHundredPctMaxWidth = oneHundredPctMaxWidth;
exports.oneHundredPctHeight = oneHundredPctHeight;
exports.oneHundredPctMaxHeight = oneHundredPctMaxHeight;
exports.alignItemsCenter = alignItemsCenter;
exports.alignItemsFlexStart = alignItemsFlexStart;
exports.alignItemsFlexEnd = alignItemsFlexEnd;
exports.alignSelfStart = alignSelfStart;
exports.alignSelfCenter = alignSelfCenter;
exports.alignSelfEnd = alignSelfEnd;
exports.justifyContentCenter = justifyContentCenter;
exports.justifyContentSpaceBetween = justifyContentSpaceBetween;
exports.justifyContentSpaceAround = justifyContentSpaceAround;
exports.justifyContentFlexStart = justifyContentFlexStart;
exports.justifyContentFlexEnd = justifyContentFlexEnd;
exports.mInnerSpace = mInnerSpace;
exports.sInnerSpace = sInnerSpace;
exports.xsInnerSpace = xsInnerSpace;
exports.xxsInnerSpace = xxsInnerSpace;
exports.xxsGap = xxsGap;
exports.mGap = mGap;
exports.xxsVerticalBlockSpace = xxsVerticalBlockSpace;
exports.xxsBottomBlockSpace = xxsBottomBlockSpace;
exports.xsBottomBlockSpace = xsBottomBlockSpace;
exports.mBottomBlockSpace = mBottomBlockSpace;
exports.lBottomBlockSpace = lBottomBlockSpace;
exports.lTopBlockSpace = lTopBlockSpace;
exports.emptyRules = emptyRules;
exports.flexDirectionRow = flexDirectionRow;
exports.flexDirectionColumn = flexDirectionColumn;
exports.autoSizeAllPlaceNeeded = autoSizeAllPlaceNeeded;
exports.autoSizeAllPlaceAvailable = autoSizeAllPlaceAvailable;
exports.autoSizeNoResizing = autoSizeNoResizing;
exports.displayInlineFlex = displayInlineFlex;
exports.displayInline = displayInline;
/* default Not a pure module */
